var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E44D26;}\r\n\t.st1{fill:#F16529;}\r\n\t.st2{fill:#EBEBEB;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    className: "st0",
    points: "145.7,401.1 122.5,140.7 377.5,140.7 354.3,401 249.8,430  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_10_",
    className: "st1",
    points: "250,407.9 334.4,384.5 354.3,162 250,162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9_",
    className: "st2",
    points: "250,258.6 207.7,258.6 204.8,225.9 250,225.9 250,194 249.9,194 169.9,194 170.7,202.5  178.5,290.5 250,290.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8_",
    className: "st2",
    points: "250,341.5 249.9,341.6 214.3,331.9 212,306.5 194.7,306.5 180,306.5 184.4,356.6  249.9,374.8 250,374.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M146.2,70h16.2v16h14.8V70h16.2v48.5h-16.2v-16.3h-14.8v16.3h-16.2L146.2,70L146.2,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M214.8,86.1h-14.3V70h44.8v16.1h-14.3v32.4h-16.2L214.8,86.1L214.8,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M252.5,70h16.9l10.4,17.1L290.2,70h16.9v48.5H291V94.5l-11.2,17.3h-0.3l-11.2-17.3v24.1h-15.9V70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M315.2,70h16.2v32.5h22.8v16h-39V70z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3_",
    className: "st3",
    points: "249.9,258.6 249.9,290.5 289.2,290.5 285.5,331.9 249.9,341.5 249.9,374.8 315.3,356.6  315.8,351.2 323.3,267.2 324.1,258.6 315.5,258.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st3",
    points: "249.9,194 249.9,213.8 249.9,225.8 249.9,225.9 326.9,225.9 326.9,225.9 327,225.9  327.7,218.7 329.1,202.5 329.9,194  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.8af6948df811f46a0eadbe39ad98638b.svg";
export { ForwardRef as ReactComponent };